/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { Router, ActivatedRoute, NavigationEnd, Data } from '@angular/router';
import { MenuService } from './shared/services/menu.service';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  public menu: any;

  constructor(
    private analytics: AnalyticsService,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService) {}

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.router.events.subscribe((res) => {
      if (res instanceof NavigationEnd) {
        if (res.url === '/') {
          this.router.navigate(['/login']);
        }
        //console.log('Navi' + res.url);
      }
      // console.log('url', this.router.url);
      // Make menu selected
      //document.querySelector(`.menu-items li a[href^='${this.router.url.split('/'[1])}']`).className = 'active'

      // Select Menu Navigation
      /*const cols = document.querySelectorAll('.menu-items li a');

      cols.forEach(e => {

        // console.log('url', this.router.url);
        // console.log('href', e.getAttribute('href'));

        if (this.router.url === e.getAttribute('href')) {
          e.classList.add('active');
        } else {
          e.classList.remove('active');
        }
      });*/

      // // console.log(this.router.url,"Current URL");
    });
  }
}
